import React from "react";
import {Col, Divider, Row} from "antd";
import "../css/student.css";

export default class FieldsViewBlock extends React.Component<{
    blockName: String,
    viewFields: String[],
    fields: any,
    data: any,
    formatter?: (field, value) => any,
}, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        let viewFields: any = this.props.viewFields;
        let fields = this.props.fields;
        let data = this.props.data;
        let formatter = (field, value) => value;

        if (this.props.formatter) {
            formatter = this.props.formatter;
        }

        return <div>
            <Divider orientation="left">{this.props.blockName}</Divider>
            <Row>
                {viewFields.map((field) => {
                    return <Col span={12} key={"view-block-field-"+field}>
                        <Row>
                            <Col span={8} className="field-key-col">{fields[field].name}</Col>
                            <Col span={16} className="field-value-col">{formatter(field, data[field])}</Col>
                        </Row>
                    </Col>
                })}
            </Row>
        </div>
    }
}